export default __webpack_public_path__ + "static/media/Liberator's Greatsword.0ae1ea0d.jpg";